var _path, _path2, _circle, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclein3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 489,
    viewBox: "0 0 488 489",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.729 40.7806C240.701 38.8177 242.269 37.2002 244.233 37.2055C246.196 37.2107 247.755 38.8365 247.717 40.7993L247.266 63.6118C247.233 65.2972 245.84 66.6338 244.154 66.6293C242.468 66.6248 241.082 65.2808 241.058 63.5953L240.729 40.7806Z",
    fill: "#BEDFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M451.554 244.409C451.554 359.284 358.429 452.409 243.554 452.409C128.679 452.409 35.5542 359.284 35.5542 244.409C35.5542 129.533 128.679 36.4086 243.554 36.4086C358.429 36.4086 451.554 129.533 451.554 244.409ZM66.7542 244.409C66.7542 342.053 145.91 421.209 243.554 421.209C341.198 421.209 420.354 342.053 420.354 244.409C420.354 146.765 341.198 67.6086 243.554 67.6086C145.91 67.6086 66.7542 146.765 66.7542 244.409Z",
    fill: "#3B3D4B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 436.708,
    r: 15.5,
    fill: "#BEDFFF",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 51.9086,
    r: 15.5,
    fill: "#BEDFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4959 243.323C35.4959 358.298 128.702 451.503 243.677 451.503C358.652 451.503 451.857 358.298 451.857 243.323C451.857 128.348 358.652 35.1418 243.677 35.1418C128.702 35.1418 35.4959 128.348 35.4959 243.323ZM420.673 243.323C420.673 341.075 341.429 420.319 243.677 420.319C145.925 420.319 66.6807 341.075 66.6807 243.323C66.6807 145.57 145.925 66.3266 243.677 66.3266C341.429 66.3266 420.673 145.57 420.673 243.323Z",
    fill: "#BEDFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclein3);
export default __webpack_public_path__ + "static/media/circlein3.750269c0b750312fa128fed64d9f5f9c.svg";
export { ForwardRef as ReactComponent };